 (function () {  
    const scrollList = root => root.querySelector('.cart-drawer-upsell-list[data-list-style-cart-drawer="scroll"]');
    function updateNavigation(root) {
      const list = scrollList(root);
      if (!list) return;
      const maximum = Math.max(0, list.scrollWidth - list.clientWidth);
      const left = Math.max(0, Math.min(maximum, list.scrollLeft));
      const previous = root.querySelector('.cart-drawer-upsell-prev');
      const next = root.querySelector('.cart-drawer-upsell-next');
      if (previous) previous.disabled = left <= 1;
      if (next) next.disabled = left >= maximum - 1;
    }
    document.addEventListener('click', event => {
      const button = event.target.closest('.cart-drawer-upsell-prev,.cart-drawer-upsell-next');
      const root = button?.closest('#cart-drawer-upsell');
      const list = root && scrollList(root);
      if (!list || button.disabled) return;
      event.preventDefault();
      const items = [...list.querySelectorAll('.cart-drawer-upsell-list-item')];
      if (items.length < 2) return;
      const positions = items.map(item => item.offsetLeft - items[0].offsetLeft);
      const current = positions.reduce((best, position, index) => Math.abs(position - list.scrollLeft) < Math.abs(positions[best] - list.scrollLeft) ? index : best, 0);
      const direction = button.matches('.cart-drawer-upsell-next') ? 1 : -1;
      const index = Math.max(0, Math.min(items.length - 1, current + direction));
      list.scrollTo({left:positions[index],behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    });
    document.addEventListener('scroll', event => {
      if (event.target.matches?.('.cart-drawer-upsell-list')) updateNavigation(event.target.closest('#cart-drawer-upsell'));
    }, true);
    window.addEventListener('resize', () => document.querySelectorAll('#CartDrawer #cart-drawer-upsell').forEach(updateNavigation));
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
      requestAnimationFrame(() => updateNavigation(wrapper));
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))
 
            insertSectionCartDrawer()
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();
